module.exports = __webpack_public_path__ + "static/media/bill-pay-graphic.368867de.png";